import { ChannelDoc } from '@gooduncles/gu-app-schema';
import { Spin } from 'antd';
import { FC, useEffect, useMemo, useState } from 'react';

import { observeChannels } from 'src/utils/firebase/firebase-short-cut';

import ChannelForm from './ChannelForm';
import ChannelTable from './ChannelTable';

export type ChannelTab = 'general' | 'store';

const ChannelList: FC = () => {
  const [rowData, setRowData] = useState<ChannelDoc[]>([]);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState<ChannelTab>('general');
  const [formOpen, setFormOpen] = useState(false);
  const [editingChannel, setEditingChannel] = useState<ChannelDoc | null>(null);

  useEffect(() => {
    setLoading(true);
    const subscription = observeChannels([], {
      sortKey: 'createdAt',
      orderBy: 'desc',
    }).subscribe({
      next: (channels) => {
        setRowData(channels);
        setLoading(false);
      },
    });
    return () => subscription.unsubscribe();
  }, []);

  const generalChannels = useMemo(() => rowData.filter((ch) => ch.type !== 'store'), [rowData]);
  const storeChannels = useMemo(() => rowData.filter((ch) => ch.type === 'store'), [rowData]);

  const filteredData = activeTab === 'store' ? storeChannels : generalChannels;

  const handleEdit = (channel: ChannelDoc) => {
    setEditingChannel(channel);
    setFormOpen(true);
  };

  const handleCreate = () => {
    setEditingChannel(null);
    setFormOpen(true);
  };

  const handleClose = () => {
    setFormOpen(false);
    setEditingChannel(null);
  };

  return (
    <div className='height100 flexColumn'>
      {loading ? (
        <div className='height100 flexRow flexCenter'>
          <Spin size='large' />
        </div>
      ) : (
        <ChannelTable
          rowData={filteredData}
          activeTab={activeTab}
          generalCount={generalChannels.length}
          storeCount={storeChannels.length}
          onTabChange={setActiveTab}
          onEdit={handleEdit}
          onCreate={handleCreate}
        />
      )}
      <ChannelForm open={formOpen} onClose={handleClose} editingChannel={editingChannel} />
    </div>
  );
};

export default ChannelList;
